/**
 * 筛选记忆跨整页刷新快照（通用，不绑定具体页面）。
 *
 * 设计：
 * - 业务组件跳转"打印/详情"等流程前，dispatch('backupFilterMemory')，
 *   本模块把 vuex 中除"运行时/非筛选"字段外的整个筛选记忆写入 sessionStorage 并打一次性标记；
 * - 流程中任意一次整页刷新（打印页 reload / F5）后，应用启动时若发现标记，
 *   store 会用快照内容整包还原全部筛选记忆并消费掉标记；
 * - 普通手动刷新没有标记，store 保持默认空态（筛选照旧清空），符合原有语义。
 *
 * 新页面接入：流程跳转前调用 this.$store.dispatch('backupFilterMemory') 即可，
 * 无需登记任何 key——快照默认覆盖整个 vuex state，仅跳过下方 NON_FILTER_KEYS 黑名单。
 */
const SNAPSHOT_KEY = 'FILTER_MEMORY_SNAPSHOT';
const SNAPSHOT_FLAG_KEY = 'FILTER_MEMORY_SNAPSHOT_FLAG';

// 非筛选的运行时/大结果字段：快照与恢复均跳过（其余 key 一律视为筛选记忆，整包处理）
const NON_FILTER_KEYS = [
  'CURRENT_DATE', // 日期取当天
  'pkList', 'confirm_PK_list', 'PK_ID', 'PK_CODE', // 盘库运行时/结果
  'SHOW_KC', // 库存开关
  'SAVE_PANENAME', 'SAVE_OTHER_PANENAME',
  'TAB_SALES_DATE',
  'isAddBtnToProduct', // 购物车入口运行时标记
  'UNREAD_INFORMATION_LIST', // 预约未读列表，刷新后重新拉取
  'APPOINTMENT_INTERVAL_ID', // 定时器 ID，跨刷新无效
  'DELIVERY_TASK_PROGRESS',
  'pageParams',
  'stock_enter_detail',
  'ITEM_SALES_SCHEDULE',
];

// 跳转前备份：把 vuex 中的筛选记忆整体快照到 sessionStorage 并打一次性标记
export function writeFilterMemorySnapshot(state) {
  const snapshot = {};
  Object.keys(state).forEach((key) => {
    if (NON_FILTER_KEYS.indexOf(key) !== -1) return;
    if (state[key] === undefined || state[key] === null) return; // 空态不写，保持默认
    snapshot[key] = state[key];
  });
  try {
    sessionStorage.setItem(SNAPSHOT_KEY, JSON.stringify(snapshot));
    sessionStorage.setItem(SNAPSHOT_FLAG_KEY, '1');
  } catch (e) {
    // 配额/序列化异常：静默失败，本次流程刷新不恢复（不阻断跳转）
  }
}

// 应用启动时调用：有标记则整包恢复全部筛选记忆，并消费标记（一次性）
export function readFilterMemorySnapshot() {
  try {
    if (sessionStorage.getItem(SNAPSHOT_FLAG_KEY) === '1') {
      const raw = sessionStorage.getItem(SNAPSHOT_KEY);
      if (raw) {
        const saved = JSON.parse(raw);
        const restored = {};
        Object.keys(saved).forEach((key) => {
          if (NON_FILTER_KEYS.indexOf(key) === -1) {
            restored[key] = saved[key];
          }
        });
        return restored;
      }
    }
  } catch (e) {
    // 快照损坏则忽略，走默认空态
  } finally {
    sessionStorage.removeItem(SNAPSHOT_FLAG_KEY);
    sessionStorage.removeItem(SNAPSHOT_KEY);
  }
  return {};
}



//////////////////
// WEBPACK FOOTER
// ./store/filterMemory.js
// module id = null
// module chunks = 